import { ButtonBlock, ButtonSize } from "sharedTypes/builder"

// Defaults applied to button blocks created before these attributes existed,
// chosen so existing emails render exactly as they did previously
// (medium font size, 6px corners, 12px/32px padding, bold text).
export const BUTTON_DEFAULTS = {
  size: "medium" as ButtonSize,
  borderRadius: 6,
  padding: 12,
  bold: true,
}

// Size presets map to the button text font size. "medium" matches the
// previous default appearance (inherited 16px).
export const BUTTON_FONT_SIZES: Record<ButtonSize, number> = {
  small: 12,
  medium: 16,
  large: 22,
}

// A single padding slider drives the vertical padding; horizontal padding is
// kept proportionally wider so the button keeps its pill shape. The default
// (12) yields "12px 32px", matching the previous hard-coded value.
export const horizontalPadding = (padding: number) => padding + 20

export const buttonStyles = (data: ButtonBlock["data"]) => {
  const fontSize = BUTTON_FONT_SIZES[data.size] ?? BUTTON_FONT_SIZES[BUTTON_DEFAULTS.size]
  const padding = data.padding ?? BUTTON_DEFAULTS.padding
  const borderRadius = data.borderRadius ?? BUTTON_DEFAULTS.borderRadius
  const bold = data.bold ?? BUTTON_DEFAULTS.bold

  return {
    fontSize: `${fontSize}px`,
    fontWeight: bold ? "bold" : "normal",
    paddingTop: `${padding}px`,
    paddingBottom: `${padding}px`,
    paddingLeft: `${horizontalPadding(padding)}px`,
    paddingRight: `${horizontalPadding(padding)}px`,
    borderRadius: `${borderRadius}px`,
  }
}
